$(document).ready(function(){
	
    // detect mobile browsers
    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // if mobile browser, get the value of the current viewport taking the browser’s interface into account (the fixed footer nav at the bottom of safari/chrome) and reset the vh unit value based on pixels
    if ( isMobile() ) {
        
        $('.mobile-vh-unit-fix').each(function () { 
            
            let vh = window.innerHeight * 0.01;
            $(this).attr('style', '--vh:' + vh + 'px');

            $(window).resize(function () {
                let vh = window.innerHeight * 0.01;
                $(this).attr('style', '--vh:' + vh + 'px');
            });
        });
    }
});